import React from "react";
import styled from "styled-components";
import TopBanner from "../components/TopBanner";

const Carrers = () => {
  return (
    <>
      <TopBanner content={"Carrers"} />
      <Wrapper>
        <h1 id="heading">
          Be a Part of Something That <span>Empowers Millions</span>
        </h1>
        <ContentWrapper>
          {/* <ImageWrapper>
            <img src="/assets/aboutPageImg.png" alt="About Us" />
          </ImageWrapper> */}
          <Content>
            <p>
              At <BrandWrapper>Wealthies.in</BrandWrapper>, we’re building more
              than just a company we’re creating a movement toward financial
              clarity and empowerment. If you believe in the power of knowledge
              and want to be part of a fast-growing, purpose-driven team your
              journey starts here.
            </p>

            <h1>Current Openings</h1>
          </Content>
        </ContentWrapper>

        <Cards>
          <Card>
            <Icon className="fa-solid fa-coins"></Icon>
            <CardContent>
              <h5>Relationship Manager</h5>
              <p>
                Connect with potential associates and professionals looking to
                grow their business with our verified lead solutions. Build
                trust, understand their needs, and offer the right solutions
                while nurturing long-term partnerships.
              </p>
            </CardContent>
          </Card>

          <Card>
            <Icon className="fa-solid fa-shield-halved"></Icon>
            <CardContent>
              <h5>Financial Assistant</h5>
              <p>
                Support customers with basic financial queries and planning. A
                great opportunity for those eager to learn and grow in the world
                of financial education.
              </p>
            </CardContent>
          </Card>

          <Card>
            <Icon className="fa-solid fa-users"></Icon>
            <CardContent>
              <h5>Customer Support Executive</h5>
              <p>
                Deliver a seamless experience to our users. Answer queries,
                provide platform assistance, and be the go-to person for
                support.
              </p>
            </CardContent>
          </Card>

          <Card>
            <Icon className="fa-solid fa-users"></Icon>
            <CardContent>
              <h5>Team Lead</h5>
              <p>
                Lead a motivated team, drive performance, and build a strong
                service culture. Perfect for natural leaders who thrive in
                dynamic, fast-paced environments.
              </p>
            </CardContent>
          </Card>
        </Cards>
        <Content>
          <h1>
            Why Work <span>With Us?</span>
          </h1>
          <ul>
            <li>Fast-growing startup with a clear purpose</li>
            <li>Open, collaborative, and flexible work culture</li>
            <li>Learn directly from core team members</li>
            <li>Contribute to a brand that’s creating real impact</li>
            <li>Strong career growth and skill-building opportunities</li>
          </ul>

          <h1>
            How to <span>Apply </span>
          </h1>
          <p>
            Send your resume to{" "}
            <a href="mailto:hr@wealthies.in">
              <b> hr@wealthies.in </b>
            </a>
            Please mention the Job Title in the subject line. We’ll connect with
            you if your profile matches our current hiring needs.
          </p>
        </Content>
      </Wrapper>
    </>
  );
};

export default Carrers;

export const BrandWrapper = styled.span`
  color: #005f73 !important;
  font-weight: bold;
`;
const Wrapper = styled.div`
  padding: 80px 5%;
  max-width: 1400px;
  margin: 0 auto;

  #heading {
    text-align: center;
    /* font-size: 2.8rem; */
    color: #005f73;
    margin-bottom: 40px;
  }
  span {
    color: #fdc500;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5%;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const Content = styled.div`
  flex: 1 1 40%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  a {
    color: #005f73;
    text-decoration: underline;
  }

  h1 {
    font-size: 2.5rem;
    color: #005f73;
    margin: 0;
  }

  p,
  ul {
    font-size: 1.1rem;
    line-height: 1.7;
    color: #333;
  }

  @media (max-width: 900px) {
    h1 {
      font-size: 2rem;
    }
  }
`;

const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  margin-top: 80px;
  margin-bottom: 80px;

  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }

  .card-body i {
    font-size: 2rem;
    background: linear-gradient(135deg, #005f73, #00aaff);
    color: #fff;
    padding: 18px;
    border-radius: 50%;
    box-shadow: 0 8px 20px rgba(0, 119, 204, 0.3);
    transition: transform 0.4s ease;
  }

  .card:hover .card-body i {
    transform: scale(1.2) rotate(10deg);
  }

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .card-content h5 {
    font-size: 1.4rem;
    color: #003366;
    margin: 0;
  }

  .card-content p {
    font-size: 1rem;
    color: #333;
    margin: 0;
    line-height: 1.5;
  }

  @media (max-width: 900px) {
    gap: 30px;

    .card {
      width: 90%;
    }
  }
`;

const Card = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 50px 30px 30px;
  width: 300px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition:
    transform 0.4s ease,
    box-shadow 0.4s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  text-align: center;

  &:hover {
    transform: translateY(-15px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
`;

const Icon = styled.i`
  font-size: 2.2rem;
  color: #005f73;
`;

const CardContent = styled.div`
  h5 {
    font-size: 1.3rem;
    color: #005f73;
    margin: 0 0 5px 0;
  }

  p {
    margin: 0;
    color: #555;
    font-size: 1rem;
  }
`;
